import { Component, OnInit } from '@angular/core';
import { UtilsService } from '../utils.service';
import { RuntimeService } from '../runtime.service';
import { AdminService } from '../admin.service';
import { ArcService } from '../arc.service';
import { RatingService } from '../rating.service';
import { PageService } from '../page.service';
import { RTagGroupService } from '../r-tag-group.service';
import { DbRecordService } from '../db-record.service';

@Component({
  selector: 'app-admin-dashboard',
  templateUrl: './admin-dashboard.component.html',
  styleUrls: ['./admin-dashboard.component.css']
})
export class AdminDashboardComponent implements OnInit {
  editProjectUsers = false;
  rtagDownloadMessage = '';

  constructor(
    private rts: RuntimeService,
    public utils: UtilsService,
    private arcs: ArcService,
    private ads: AdminService,
    private rs: RatingService,
    private dbrs: DbRecordService,
    private pgs: PageService,
    private rtgs: RTagGroupService
  ) { }

  ngOnInit() {

  }

  exportArticleIds() {
    const p = this.rts.currentProject;
    this.utils.saveExport(p.recordIds, `${p.shortcut}-idsExport.json`);
  }

  switchEditProjectUsers() {
    this.editProjectUsers = !this.editProjectUsers;
  }

  serverBackup() {
    const p = this.rts.currentProject;
    if (!p) {
      return alert('NO PROJECT SELECTED');
    }
    let obs = this.arcs.run({
      fun: 'backupProject',
      projectId: p.id
    });

    obs.subscribe((resp) => {
      console.log('BACKUP PROJECT FINISHED', resp);
    });
  }

  backup() {
    const p = this.rts.currentProject;
    if (!p) {
      return alert('NO PROJECT SELECTED');
    }
    let dct = {};
    dct = {
      abstractRatings: p.abstractRatingsBackup,
      fulltextRatings: p.fulltextRatingsBackup,
      ratingTags: this.rs.rTagsGroups,
      ratingTagsRecords: p.ratingTagsBackup,
      notes: p.notesBackup
    };
    this.utils.saveExport(dct, `backup-${this.rts.currentProject.shortcut}.json`);
    console.log('BACKUP:', dct);

  }

  /*
  downloadRTags(start, tp) {
    let end = start + 800;
    this.rtagDownloadMessage = `tag downlad ${start}-${end}`;
    let obs = this.rtgs.checkRecords(this.pgs.lastRecords.slice(start, end));
    if (!obs) {
      switch (tp) {
        case 'csv': return this.saveCSV(false, end);
        case 'csv-expanded': return this.saveCSV(true, end);
        case 'endnote': return this.saveEndnote(end);
      }
    }

    obs.subscribe(x => {
      switch (tp) {
        case 'csv': return this.saveCSV(false, end);
        case 'csv-expanded': return this.saveCSV(true, end);
        case 'endnote': return this.saveEndnote(end);
      }
    });
  }
  */

  saveEndnote(checkStart?) {
    checkStart = checkStart || 0;
/*
    if (checkStart < this.pgs.lastRecords.length) {
      return this.downloadRTags(checkStart, 'endnote');
    }
    */
    this.rtagDownloadMessage = '';

    let ls = [];

    this.pgs.lastRecords.forEach(dbr => {
      ls.push(dbr.endnoteExport(this.rtgs.getRTags(dbr)));
    });

    this.utils.saveExport(ls.join('\n\n'),
      'export.ris', { raw: true });
  }


  saveRatingsJSON() {
    const ls = [];
    this.pgs.lastRecords.forEach(dbr => {
      ls.push(dbr.jsonExport(this.rtgs.getRTags(dbr)));
    });
    this.utils.saveExport(ls, 'ratings.json');
  }

  saveCSV(isExpanded, checkStart?) {
    checkStart = checkStart || 0;
/*
    if (checkStart < this.pgs.lastRecords.length) {
      return this.downloadRTags(checkStart, `csv${isExpanded ? '-expanded' : ''}`);
    }
*/
    this.rtagDownloadMessage = '';

    let ls = [];
    let titles = ['Title', 'Authors', 'Year', 'Source', 'Volume(Issue), Pages', 'DOI',
      'Excluded'
    ];
    this.rts.currentProject.abstractRejectIds.forEach(x => titles.push(x));
    titles.push('Included');
    this.rts.currentProject.abstractAcceptIds.forEach(x => titles.push(x));

    this.rts.currentProject.rtags.forEach(tpl => {
      titles.push(tpl[0]['title']);
      if (isExpanded)
        tpl[1].forEach(x => titles.push(x['title']));
    });

    ls.push(titles);
    this.pgs.lastRecords.forEach(dbr => {
      ls.push(dbr.csvExportList(this.rtgs.getRTags(dbr), isExpanded));
    });


    // let ls = [["aa'a", '"bbb"', "ccc"], ["111", "222", "333"]]
    this.utils.saveExport(require('javascript-csv').fromArrays(ls),
      isExpanded ? 'export-expanded.csv' : 'export.csv',
      { raw: true });
  }

}



// WEBPACK FOOTER //
// /GIT/Search-manager/rating-module/src/app/admin-dashboard/admin-dashboard.component.ts